/**
 * Banner Search Widget
 */

const Search = () => {
  /**
   * Banner Search Only
   * =======
   */
  const searchForm = document.querySelector('.banner__search .search-form'); // Banner wrapper
  if (searchForm) {
    const searchToggle = searchForm.querySelector('.search-form__toggle'); // Banner top (used on desktop)
    const searchField = searchForm.querySelector('.search-form__field'); // Banner top (used on desktop)

    const closeForm = (e) => {
      if (searchForm && !searchForm.contains(e.target) && searchForm.classList.contains('open')) {
        // Clicked outside nav (let's do stuff)
        searchForm.classList.remove('open');
      }
    };

    if (searchToggle) {
      searchToggle.addEventListener('click', (e) => {
        e.preventDefault();
        searchForm.classList.toggle('open'); // Used to update the cta background color

        if (searchForm.classList.contains('open') && searchField) {
          setTimeout(() => {
            searchField.focus();
          }, 500);
        }
      });

      document.addEventListener('click', (e) => {
        closeForm(e);
      });

      // Close search if focus is outside of searchForm (use focusin as it bubbles up to the document)
      document.addEventListener('focusin', (e) => {
        if (searchForm.contains(e.target)) {
          // Clicked in searchForm area (business as usual)
        } else {
          // Clicked outside searchForm (let's do stuff)
          closeForm(e);
        }
      });
    }
  }

  /**
   * All search forms
   * =======
   */
  const [...searchForms] = document.querySelectorAll('.search-form');
  const searchInputClass = 'has-input';
  if (searchForms.length > 0) {
    searchForms.map((form) => {
      const searchInput = form.querySelector('.search-form__field');

      // allows for "has input" states
      searchInput?.addEventListener('keyup', ({ target }) => {
        if (target.value !== '') {
          form.classList.add(searchInputClass);
          return;
        }
        form.classList.remove(searchInputClass);
      });
    });
  }
};

export default Search;
